import { apiClient } from '../../core/api';
import type { ProviderKind } from '../../core/providers';
import type { ProviderDraft } from './draft';

export type ProviderProtocol = 'chat-completions' | 'responses' | 'anthropic' | 'gemini';
export type VendorField = 'name' | 'protocol' | 'baseUrl' | 'purpose' | 'logo';
export interface ProviderVendor {
  id: string;
  name: string;
  protocol: ProviderProtocol;
  baseUrl: string;
  purpose: 'chat' | 'image' | 'tts';
  logo: string;
  locks: Record<VendorField, boolean>;
}

export const PROTOCOL_LABELS: Record<ProviderProtocol, string> = {
  'chat-completions': 'Chat Completions', responses: 'Responses', anthropic: 'Anthropic', gemini: 'Gemini',
};
export const EMPTY_VENDOR_LOCKS: Record<VendorField, boolean> = {
  name: false, protocol: false, baseUrl: false, purpose: false, logo: false,
};

export function protocolKind(protocol: ProviderProtocol): ProviderKind {
  return protocol === 'anthropic' || protocol === 'gemini' ? protocol : 'openai';
}

export function draftProtocol(draft: Pick<ProviderDraft, 'kind' | 'protocol'>): ProviderProtocol {
  return draft.protocol ?? (draft.kind === 'anthropic' || draft.kind === 'gemini' ? draft.kind : 'chat-completions');
}

export async function fetchProviderVendors(signal?: AbortSignal): Promise<ProviderVendor[]> {
  return (await apiClient.request<{ vendors: ProviderVendor[] }>('/v1/provider-vendors', { signal, cache: 'no-store' })).vendors;
}

export function applyVendor(draft: ProviderDraft, vendor: ProviderVendor, lockedOnly = false): ProviderDraft {
  const patch: Partial<ProviderDraft> = { vendorId: vendor.id };
  for (const field of Object.keys(EMPTY_VENDOR_LOCKS) as VendorField[]) {
    if (!lockedOnly || vendor.locks[field]) Object.assign(patch, { [field]: vendor[field] });
  }
  const next = { ...draft, ...patch };
  next.kind = protocolKind(draftProtocol(next));
  return next;
}
